import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"
import { removeEmptyFormValues } from "@lib/utils"

// Connects to data-controller="filter"
export default class extends Controller {

  static targets = ["form", "query"]
  static values = {
    submitOnQuery: { type: Boolean, default: false },
    delay: { type: Number, default: 350 }
  }

  initialize() {
    this.debounceSubmit = debounce(this.submit.bind(this), this.delayValue)
  }

  connect() {
    if (this.hasQueryTarget) {
      this.restorePendingQuery()
      this.queryTarget.setSelectionRange(this.queryTarget.value.length, this.queryTarget.value.length)
    }
    this.selectInputs = Array.from(this.element.querySelectorAll("select"))
    this.setDefaults()
  }

  disconnect() {
    this.debounceSubmit.clear?.()
  }

  setDefaults() {
    if (this.hasQueryTarget && this.submitOnQueryValue) {
      this.queryTarget.setAttribute("data-action", "input->filter#onInputQuery")
    }
  }

  submit(e) {
    const table = this.loadingTable()
    table?.classList.add("loading")
    removeEmptyFormValues(this.formTarget)
    this.formTarget.requestSubmit()
  }

  onInputQuery(e) {
    this.constructor.pendingQueryValue = this.queryTarget.value
    this.constructor.pendingQueryKey = this.currentQueryKey()

    this.queryTarget.value ? this.debounceSubmit() : this.submit()
  }

  restorePendingQuery() {
    if (this.constructor.pendingQueryKey !== this.currentQueryKey()) {
      this.clearPendingQuery()
      return
    }

    const pendingQueryValue = this.constructor.pendingQueryValue
    if (pendingQueryValue === undefined) return

    if (this.queryTarget.value === pendingQueryValue) {
      this.clearPendingQuery()
      return
    }

    this.queryTarget.value = pendingQueryValue
    this.queryTarget.value ? this.debounceSubmit() : this.submit()
  }

  currentQueryKey() {
    return `${window.location.pathname}:${this.formTarget.action}`
  }

  clearPendingQuery() {
    this.constructor.pendingQueryValue = undefined
    this.constructor.pendingQueryKey = undefined
  }

  loadingTable() {
    let element = this.element.nextElementSibling

    while (element) {
      if (element.matches("table")) return element

      const table = element.querySelector("table.collection-table, table.table")
      if (table) return table

      element = element.nextElementSibling
    }
  }

  onChange(e) {
    this.submit()
  }

}
